import { dispatcher } from 'dispatcher';
import { useEffect } from 'react';

export const useCMSIntegration = ({ page, fetchPageInfo }) => {
    useEffect(() => {
        if (!page) {
            return;
        }

        window.initPageAdminUI?.(page);

        // Re-fetch page info by CMS when needed.
        const reFetchPageInfo = () => fetchPageInfo(Date.now());

        dispatcher.listen('page:update:request', reFetchPageInfo);

        return () => {
            dispatcher.removeListener('page:update:request', reFetchPageInfo);
        };
    }, [page, fetchPageInfo]);
};
